import { SpyneTrait, ViewStream } from "spyne";
import { StringCloneUtilsTraits } from "traits/string-clone-utils-traits";
import { UtilTraits } from "traits/util-traits";

const baseAttrStr = `
       new ViewStream({
           style:   "font-family:sans-serif;",
           tagName: "p",
           data:    "Hello World"
           
           
           
       }).appendToDom(document.body);
    `;

export class CodePlaygroundExamplesAttributesTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeplaygroundAttr$";

    super(context, traitPrefix);
  }

  static codeplaygroundAttr$Default() {
    const vs = new ViewStream({ data: "Hello World" });
    vs.appendToDom(this.props.el.contentDocument.body);
    this.codePlaygroundExamples$UtilUpdateDefineHeight(200, 326, 300);
    return `
   import {ViewStream} from 'spyne';

   new ViewStream({
      data: "Hello World"
    }).appendToDom(document.body);    
           
    `;
  }

  static codeplaygroundAttr$DefaultParagraph() {
    const vs = new ViewStream({ data: "Hello World" });
    vs.appendToDom(this.props.el.contentDocument.body);
    this.codePlaygroundExamples$UtilUpdateDefineHeight(200, 206);
    return `
   import {ViewStream} from 'spyne';

   new ViewStream({
      tagName: "p",
      data: "Hello World"
    }).appendToDom(document.body);    
           
    `;
  }


  static codeplaygroundAttr$HelloWorldVBL() {
    class HelloWorldTrait extends SpyneTrait {
      constructor(context) {

        // LOGIC Module
        super(context, "hw$");
      }

      // Trait method that rotates the array
      static hw$greet(e, byPass = false) {
        const targetId = e?.event?.target?.id;

        if (targetId !== "hw-vbl" && byPass === false) {
          return;
        }

        // Initialize the greetings array once, storing it in props
        if (!this.props.greetings) {
          this.props.greetings = [
            "Hello World",
            "Hola Mundo",
            "Bonjour le monde",
            "Hallo Welt",
            "こんにちは世界",
            "你好，世界",
            "안녕하세요 월드",
            "Привіт, світе",
            "مرحبا بالعالم",
            "Olá Mundo",
            "Ciao Mondo",
          ];
        }

        // Remove the first item
        const currentGreeting = this.props.greetings.shift();
        // Update the UI
        //this.props.el$("h2").innerText = currentGreeting;

        vs.props.el.parentElement.querySelector("h2").innerText =
          currentGreeting;
        // Re-insert the item at the end to cycle
        this.props.greetings.push(currentGreeting);

       //console.log("ARR ", { vs, currentGreeting }, this.props.greetings);

        return currentGreeting;
      }
    }

    class MainView extends ViewStream {
      constructor(props = {}) {
        // Minimal HTML: a title + a button
        props.template = `<h2></h2><button id="hw-vbl">Click Me</button>`;
        props.traits = [HelloWorldTrait]; // Use the HelloWorldTrait
        props.channels = ["CHANNEL_UI"]; // Use the built-in UI channel
        super(props);
      }

      // Map click events to the greet method
      addActionListeners() {
        return [["CHANNEL_UI_CLICK_EVENT", "hw$greet"]];
      }

      // Tell the UI channel to watch for button clicks
      broadcastEvents() {
        return [["button", "click"]];
      }

      // Show the first greeting upon render
      onRendered() {
        //.this.hw$greet();
      }
    }

    const vs = new MainView();
    vs.appendToDom(this.props.el.contentDocument.body);

    const updateHW = () => {
      const hwText = vs.hw$greet({}, true);
      vs.props.el.parentElement.querySelector("h2").innerText = hwText;
      this.codePlaygroundExamples$UtilUpdateDefineHeight(200, 326);
    };

    const onVsClick = (e) => {
     //console.log("VS CLICKED ", e, vs);

      updateHW();
    };

    //  vs.props.el.querySelector('button#hw-vbl').addEventListener('click', onVsClick);

    updateHW();

    return [
      {
        tabName: "ViewStream",

        scriptString: `
    class MainView extends ViewStream {
      constructor(props = {}) {
        
        // VIEW:          ADD CONTENT
        props.template =  \`<h2></h2>
                           \u200B<button>Click Me</button>\`;                           
         
        // BEHAVIOR:      ADD CHANNELS
        props.channels =  ["CHANNEL_UI"];    
        
        // LOGIC:         ADD METHODS
        props.traits =    [HelloWorldTrait];    
        super(props);
      }
    
      // BEHAVIOR: CONNECT EVENTS TO METHODS  
      addActionListeners() {
        return [["CHANNEL_UI_CLICK_EVENT", "hw$greet"]];
      }
    
      // BEHAVIOR: SEND LOCAL EVENTS
      broadcastEvents() {
        return [["button", "click"]];
      }
    
      // RENDER HOOK
      onRendered() {
        this.hw$greet();
      }
    }
    
    new MainView().appendToDom(document.body);`,
      },
      {
        tabName: "SpyneTrait",

        scriptString: `  class HelloWorldTrait extends SpyneTrait {
    constructor(context) {
    
      // LOGIC: Binds pure functions
      super(context, "hw$");
    }
  
    // Trait method that rotates the array
    static hw$greet() {
      // Initialize the greetings array once, 
      storing it in props
      if (!this.props.greetings) {
        this.props.greetings = [
          "Hello World", "Hola Mundo", "Bonjour le monde", 
          "Hallo Welt", "こんにちは世界", "你好，世界", 
          "안녕하세요 월드", "Привіт, світе", "مرحبا بالعالم", 
          "Olá Mundo", "Ciao Mondo"
        ];
      }
  
      // Remove the first item
      const currentGreeting = this.props.greetings.shift();
      // Update the UI
      this.props.el$("h2").el.innerText = currentGreeting;
      // Re-insert the item at the end to cycle
      this.props.greetings.push(currentGreeting);
    }
  }`,
      },
    ];
  }

  static codeplaygroundAttr$MemeGen() {
    //const vs = new ViewStream({data: "Meme Gen"});
    //  vs.appendToDom(this.props.el.contentDocument.body);

    const props = {
      tagName: "iframe",
      width: "100%",
    };

    //const iframeUrl = "../../../static/iframes/meme-gen/index.html";
    //const iframeUrl = "//holdrr.com/index.html";
    const iframeUrl = UtilTraits.util$GetIframeUrl("meme-gen/index.html");

    const loadOnFrame = () => {
      this.props.el.src = iframeUrl
      this.codePlaygroundExamples$UtilUpdateDefineHeight(620, 704);
    };

    requestAnimationFrame(loadOnFrame);

    return [
      {
        tabName: "index",
        scriptString: `  //main SCSS file for styling
  import './scss/main.scss';
  
  // SpyneJS core imports
  import { SpyneApp, ChannelFetch } from 'spyne';
  
  // Your main AppView
  import { AppView } from './app/app-view.js';
  
  // A custom channel that combines data from other channels
  import { ChannelMemeGenerator } from 'channels/channel-meme-gen.js';
  
  // Basic SpyneApp config object
  const config = {
    debug: true,
  };
  
  // Initialize the Spyne application
  SpyneApp.init(config);
  
  // Register the ChannelMemeGenerator channel
  SpyneApp.registerChannel(new ChannelMemeGenerator());
  
  
  // Define API endpoints
  const nasaUrl =
    \`https://api.nasa.gov/planetary/apod?api_key=\${NASA_API_KEY}&count=1\`;
  
  const txtUrl = '//api.quotable.io/random';
  
  // Register a ChannelFetch for "CHANNEL_MEME_IMG"
  SpyneApp.registerChannel(
    new ChannelFetch('CHANNEL_MEME_IMG', {
      url: nasaUrl,
      map: (d) => {
        if (Array.isArray(d)) {
          d = d[0];
        }
        return d;
      },
    }),
  );
  
  // Register a ChannelFetch for "CHANNEL_MEME_TXT"
  SpyneApp.registerChannel(
    new ChannelFetch('CHANNEL_MEME_TXT', {
      url: txtUrl,
    }),
  );
  
  
  // Create an instance of the main AppView and attach it to the body tag
  new AppView().appendToDom(document.body);
`,
      },

      {
        tabName: "AppView",
        scriptString: `  import { ViewStream } from 'spyne';
  import { MemeGeneratorTraits } from 'traits/meme-gen-traits.js';
    
  export class AppView extends ViewStream {
    constructor(props = {}) {
      props.tagName = 'main';
      props.id = 'meme';
      props.traits = [MemeGeneratorTraits];
      props.channels = ['CHANNEL_MEME_GENERATOR'];
      super(props);
    }
  
    addActionListeners() {
      return [
        [
          'CHANNEL_MEME_GENERATOR_UPDATE_EVENT',
          'memeGenerator$CreateMemeFromTxtAndImg',
        ],
      ];
    }
  }
`,
      },

      {
        tabName: "MemeElement",
        scriptString: `  import { DomElement } from 'spyne';

  /**
   * MemeElement extends DomElement to create a figure element
   */
  export class MemeElement extends DomElement {
    constructor(props = {}) {
      // Configure the root &lt;figure class="meme"&gt;...
      props.tagName = 'figure';
      props.class = 'meme';
      // Assign the imported HTML template
      props.template = \`&lt;img src="{{message}}" alt="random doggo" /&gt;
        &lt;figcaption&gt;
        &lt;blockquote&gt;
                            “{{content}}”
    &lt;cite&gt;—{{author}}&lt;/cite&gt;
      &lt;/blockquote&gt;
      &lt;/figcaption&gt;
          \`;
  
      super(props);
    }
  }
`,
      },
      {
        tabName: "channel-meme-gen",
        scriptString: `  import { Channel } from 'spyne';
  import { MemeGenTraits } from 'traits/meme-gen-traits.js';
  
  export class ChannelMemeGen extends Channel {
    constructor(name, props = {}) {
      name = 'CHANNEL_MEME_GENERATOR';
      props.sendCachedPayload = false;
  
      // Attach MemeGeneratorTraits so we can call memeGenerator$ methods in this channel
      props.traits = [MemeGenTraits];
  
      super(name, props);
    }
  
    /**
     * Called when SpyneApp registers this channel.
     * Fetches text/image data via memeGenerator$GetTxtAndImg.
     */
    onRegistered() {
      this.memeGenerator$GetTxtAndImg();
    }
  
    /**
     * Declare actions this channel can broadcast or handle.
     */
    addRegisteredActions() {
      return ['CHANNEL_MEME_GENERATOR_UPDATE_EVENT'];
    }
  
    /**
     * (Optional) Called when this channel receives or updates view stream info.
     */
    onViewStreamInfo() {}
  }
`,
      },
      {
        tabName: "meme-gen-traits",
        scriptString: `  import { ViewStream } from 'spyne';
  import { MemeGeneratorTraits } from 'traits/meme-gen-traits.js';
    
  export class AppView extends ViewStream {
    constructor(context) {
      let traitPrefix = 'memeGenerator$';
      super(context, traitPrefix);
    }
  
    /**
     * 1) Merges the next emission from 'CHANNEL_MEME_IMG' and 'CHANNEL_MEME_TXT'.
     * 2) Subscribes once both channels have data, then calls 'memeGenerator$OnTxtAndImgReturned'.
     */
    static memeGenerator$GetTxtAndImg() {
      // 'mergeChannels' merges the next emissions from each channel into one result.
      this.mergeChannels(['CHANNEL_MEME_IMG', 'CHANNEL_MEME_TXT']).subscribe(
        this.memeGenerator$OnTxtAndImgReturned.bind(this),
      );
    }
  
    /**
     * Called after both channels have emitted. Extracts relevant data from each
     * channel's payload, then sends out a new event 'CHANNEL_MEME_GENERATOR_UPDATE_EVENT'
     * so another ViewStream or Channel can use the combined data.
     *
     * @param {Object} e - The merged channels object, for example:
     *  {
     *    "CHANNEL_MEME_IMG": { payload: { message, title } },
     *    "CHANNEL_MEME_TXT": { payload: { content, author } }
     *  }
     */
    static memeGenerator$OnTxtAndImgReturned(e) {
      // Extract the random image data; fallback title if none is provided.
      const { message, title = 'random doggo' } = e['CHANNEL_MEME_IMG'].payload;
  
      // Extract text content (content + author) from the text channel.
      const { content, author } = e['CHANNEL_MEME_TXT'].payload;
  
      // Broadcast a new payload so the rest of the system (UI, logs, etc.) knows
      // we've got a complete meme set (image + text).
      this.sendChannelPayload('CHANNEL_MEME_GENERATOR_UPDATE_EVENT', {
        message,
        title,
        content,
        author,
      });
    }
  
    /**
     * Uses the data from the event payload to create a MemeElement and append it
     * to the DOM (this.props.el is the root element for the ViewStream instance
     * that imported these methods, and uses appendChild to load the content).
     */
    static memeGenerator$CreateMemeFromTxtAndImg(e) {
      const data = e.payload;
      const memeHTML = new MemeElement({ data });
      // props.el is the root element for the ViewStream instance that imported these Trait methods,
      // so we can append our MemeElement directly to it.
      this.props.el.appendChild(memeHTML.render());
    }
  }
`,
      },
      {
        tabName: "meme-gen.scss",
        scriptType: "scss",
        scriptString: `  #meme {
    flex: 1; /* fill remaining space if you have other elements above/below */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  /* The figure that holds the image and caption */
  figure.meme {
    margin: 0;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 800px; /* optional max width so it doesn't get too large */
    max-height: 800px;
  
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  
    figcaption {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: #fff;
  
      blockquote {
        font-size: 2.25rem;
        font-family: 'Impact', 'Arial Black', monospace;
        line-height: 1.2;
        margin: 0 1rem; /* add some horizontal padding */
        /* text stroke to mimic meme-style outline */
        -webkit-text-stroke: 2px #000;
        /* optional text shadow to help separate text from background */
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.8);
  
        cite {
          display: block;
          font-size: 1rem;
          background: #000;
          padding: 8px 10px;
          letter-spacing: 1px;
          -webkit-text-stroke: 0;
          font-family: system-ui;
          margin: 1rem 0 0 1rem;
          width: fit-content;
        }
      }
    }
  }
`,
      },
    ];
  }

  static codeplaygroundAttr$HelloWorld() {
    const props = {
      tagName: "p",
      style: `font-family:sans-serif;`,
      data: "Hello World",
    };
    const vs = new ViewStream(props);
    vs.appendToDom(this.props.el.contentDocument.body);

    return baseAttrStr;
  }

  static codeplaygroundAttr$HelloWorldAnchor() {
    const props = {
      tagName: "a",
      style: "font-family:sans-serif;",
      href: "https://w3.org",
      target: "_blank",
      data: "Click Here",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    const replaceArr = [
      [`tagName: "a",`, 3],
      [`data:    "Click Here",`, 4],
      [`target:  "_blank",`, 5],
      [`href:    "https://w3.org"`, 6],
    ];

    return StringCloneUtilsTraits.stringClone$ReplaceLines(
      baseAttrStr,
      replaceArr,
    );
  }

  static codeplaygroundAttr$Img() {
    const props = {
      tagName: "img",
      width: "350px",
      src: "/./static/imgs/pexels-dylan-chan-4417072.jpg",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    const replaceArr = [
      [`tagName: "img",`, 2],
      [`width: "350px",`, 3],
      [`src:     "imgs/pexels-dylan-chan-4417072.jpg"`, 4],
      [` `, 5],
    ];

    return StringCloneUtilsTraits.stringClone$ReplaceLines(
      baseAttrStr,
      replaceArr,
    );
  }

  static codeplaygroundAttr$Input() {
    const props = {
      style: "padding:8px;font-size:1rem;",
      tagName: "input",
      size: "20",
      value: "Add text here",
      type: "text",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    const replaceArr = [
      [`tagName: "input",`, 2],
      [`type: "text",`, 3],
      [`value: "Add text here",`, 4],
      [`size: "20",`, 5],
      [`style: "padding:8px;font-size:16px;",`, 6],
    ];

    return StringCloneUtilsTraits.stringClone$ReplaceLines(
      baseAttrStr,
      replaceArr,
    );
  }

  static codeplaygroundAttr$Youtube() {
    const allowfullscreen = "allowfullscreen";

    const props = {
      tagName: "iframe",
      width: "270",
      height: "200",
      style: "border:none;",
      src: "https://www.youtube.com/embed/_Ulrc3WHinM?si=BIkdiHivZBoVUU1N",
    };

    new ViewStream(props).appendToDom(this.props.el.contentDocument.body);

    const replaceArr = [
      [`tagName: "iframe",`, 2],
      [`width : "270",`, 3],
      [`height: "200",`, 4],
      [
        `src : "https://www.youtube.com/embed/\n` +
          `         _Ulrc3WHinM?si=BIkdiHivZBoVUU1N"`,
        5,
      ],
      [`style : "border:none;"`, 6],
    ];

    const updateString = () => {
      const l7All = document.querySelectorAll("pre.line-7");
      const addNew = (l7) =>
        (l7.innerHTML = `<code class="hljs language-javascript"><span class="hljs-string class_">                  _Ulrc3WHinM?si=BIkdiHivZBoVUU1N</span></code>`);

      l7All.forEach(addNew);
    };

    window.setTimeout(updateString, 500);
    window.setTimeout(updateString, 1500);

    //console.log("ATTRIBUTES CODE GEN ELL ",this.props);

    return StringCloneUtilsTraits.stringClone$ReplaceLines(
      baseAttrStr,
      replaceArr,
    );
  }
}
